import { NgModule } from '@angular/core';

import { PairingSignalR } from './signalr/pairing.signalr';

@NgModule({
  providers: [PairingSignalR],
})
export class EraPairLibModule {
  constructor(private readonly pairingSignalr: PairingSignalR) {}
}
